"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTwoArgsFnCondition = exports.isTwoArgsFnOperator = void 0;
const twoArgsFnOperatorSet = new Set(['contains', 'beginsWith', 'type']);
const isTwoArgsFnOperator = (key) => twoArgsFnOperatorSet.has(key);
exports.isTwoArgsFnOperator = isTwoArgsFnOperator;
const isTwoArgsFnCondition = (condition) => Object.keys(condition).some(exports.isTwoArgsFnOperator);
exports.isTwoArgsFnCondition = isTwoArgsFnCondition;
